
import React from "react"
import { Link } from "react-router-dom"


const NotFound:React.FC = ()=>{

    return <section className="bg-white -gray-900">
                <div className="py-8 px-4  mx-auto max-w-screen-xl lg:py-16 lg:px-6">
                    <div className="mx-auto max-w-screen-sm flex flex-col items-center text-center">
                        <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-primary-600 -primary-500">404</h1>
                        <p className="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl -white">Something's missing.</p>
                        <p className="mb-4 text-lg font-light text-gray-500 -gray-400">Sorry, we can't find that page. You'll find lots to explore on the home page. </p>
                        <Link to={"/"} className="flex w-[200px] mt-4 justify-center rounded-md bg-brand-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-brand-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600">Back To Homepage</Link>
                    
                    </div>   
                </div>
            </section>

            
}

export default NotFound
